<template>
<div class="chapter">
<div class="inner_page">
<div id="ded">
<br/><br/><br/>
<p class="Body ParaOverride-3"><span class="Italics CharOverride-2">To Jack: Never forget the strength that lies</span> <span class="Italics _idGenCharOverride-1">within you and your ability to achieve anything.</span> <span class="Italics CharOverride-2">You make a positive impact on the world every day simply because of who you are.</span></p>
<br/>
<p class="Body ParaOverride-3"><span class="Italics _idGenCharOverride-1">With love,</span></p>
<p class="Body ParaOverride-3"><span class="Italics _idGenCharOverride-1">Your biggest fan</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 05-ded.vue?4c52e3d3